/* eslint-disable max-len */
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Container } from './styles';


const Error404 = () => {
    const loggedIn = useSelector(state => state.login.loggedIn);
    return (
        <Container>
            <section className="error-content">
                <h1> Erro 404 </h1>
                <p>Desculpa, tivemos um problema.</p>
                <Link to={loggedIn ? '/lives' : '/'}>
                    <button type="button">Página Inicial </button>
                </Link>
            </section>
        </Container>
    );
};

export default Error404;
